import { Table } from 'antd';
import React from 'react';

import { COLUMNS } from '@app/pages/Analytics/FinancialResultsReport/data';
import type { FinancialResultsReportTableProps } from '@app/pages/Analytics/FinancialResultsReport/types';
import { transformFinancialResultToTableData } from '@app/pages/Analytics/FinancialResultsReport/utils';

const HEADER_HEIGHT = 400;

export const FinancialResultsReportTable: React.FC<
  FinancialResultsReportTableProps
> = ({ isLoading, tableData }) => {
  return (
    <Table
      bordered
      columns={COLUMNS}
      dataSource={transformFinancialResultToTableData(tableData)}
      pagination={false}
      loading={isLoading}
      className="table-border-dark"
      scroll={{ x: 'max-content', y: `calc(100vh - ${HEADER_HEIGHT}px)` }}
    />
  );
};
